<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
<!--    <el-alert v-show="notice!=''"-->
<!--      :title="notice"-->
<!--      type="error"-->
<!--      effect="dark"-->
<!--      center-->
<!--      class="errorCenter">-->
<!--    </el-alert>-->


    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="imageUrl">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
<!--        <router-link class="inlineBlock" to="/">-->
<!--          <el-dropdown-item>-->
<!--            首页-->
<!--          </el-dropdown-item>-->
<!--        </router-link>-->
        <!--el-dropdown-item divided>
          <span @click="Modify()" style="display:block;">修改</span>
        </el-dropdown-item-->
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      :title="'编辑用户'"
      :visible.sync="dialogVisible"
      :close-on-click-modal=false
      class="admin">
      <el-form ref="adminForm" size="small">
        <el-form-item label="用户名：">
          <span>{{username}}</span>
        </el-form-item>
        <el-form-item label="api密钥：">
          <span>{{apiKey}}</span>
        </el-form-item>
        <el-form-item label="新密码：">
          <el-input v-model="new_password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="上传图片：">
          <el-upload
            class="avatar-uploader"
            action=" /api/uploadImg"
            :data={type:this.imageName}
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </el-menu>

</template>

<script>
  import request from '@/utils/request'
    import {mapGetters} from 'vuex'
    import Breadcrumb from '@/components/Breadcrumb'
    import Hamburger from '@/components/Hamburger'
    import {getInfo, uploadImg} from '@/api/login'
    import imagesUrlImg from "@/assets/img/56314651.jpg"
    export default {
        data() {
            return {
                notice:'321',
                //imagesUrl,
                username: '',
                old_password: '',
                new_password: '',
                dialogVisible: false,
                admin: '',
                imageUrl: imagesUrlImg,
                updateImageUrl: '',
                imageName: 'merchant',
                passwordText: '修改密码',
                avatar: '',
                apiKey: '',
                city_list: '',
            }
        },
        components: {
            Breadcrumb,
            Hamburger
        },
        computed: {
            ...mapGetters([
                'sidebar',

            ])
        },
        created() {
          // this.notice=JSON.parse(localStorage.getItem('roleData')).notice;
            this.getInfoData()

             //let roleNma=JSON.parse(localStorage.getItem('roleData')).name;
            //window.Echo.channel('export_success_'+roleNma)
            //.listen('ExportSuccessEvent', (e) => {
             // this.$notify({
              //  title: '文件生成成功',
               // dangerouslyUseHTMLString: true,
               // message: '<a href="'+e.path+'">点击下载文件</a>',
               // type: 'success',
                //duration: 100000
              //});
            //});
        },
        methods: {
            toggleSideBar() {
                this.$store.dispatch('ToggleSideBar')
            },
            logout() {
                this.$store.dispatch('LogOut').then(() => {
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            },

            Modify() {
                this.dialogVisible = true
            },

            handleDialogConfirm() {

                this.dialogVisible = false
                if (this.imageUrl === imagesUrlImg) {
                    this.avatar = "";
                }
                this.admin = {
                    avatar: this.avatar,
                    password: this.new_password,
                };

                if (this.avatar || this.new_password) {
                    uploadImg(this.admin).then(response => {//商户头像提交
                        let dataAdmin = response.data;
                        this.getInfoData()
                        if (this.admin.new_password) {
                            this.logout()
                        } else {
                            alert("修改成功")
                        }
                    })
                } else {
                    this.getInfoData()
                    this.$message('修改失败');
                }
            },

            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
                this.avatar = res.data.path;
            },

            beforeAvatarUpload(file) {

            },
            getInfoData() {

                let dataAdmin = localStorage.getItem('roleData');
                dataAdmin = JSON.parse(dataAdmin);
                this.username = dataAdmin.name;
                if (!dataAdmin.avatar) {
                    this.imageUrl = imagesUrlImg;
                } else {
                    this.imageUrl = dataAdmin.avatar;
                }
                this.apiKey = dataAdmin.api_key;

            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .errorCenter{
        position: absolute;
        top: 10px;
        width: 40%;
        margin: 0 30%;
        line-height: 100%;
      }
  .navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;

    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }



    .screenfull {
      position: absolute;
      right: 90px;
      top: 16px;
      color: red;
    }

    .avatar {
      width: 120px;
    }

    .avatar-container {
      height: 50px;
      display: inline-block;
      position: absolute;
      right: 35px;

      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }

  .admin {
    width: 30%;
    margin: auto !important;
  }

  @media (max-width: 1440px) {
    .admin {
      width: 55%;
      margin: auto;
    }
  }

  .admin .el-dialog {
    width: 100%;
    padding: 0 10%;
    box-sizing: border-box;
  }

  .admin .el-form-item__label {
    text-align: left;
    width: 5rem;
    padding: 0;
  }

  .admin .el-form-item .el-form-item__content {
    margin-left: 5rem;
    width: 70%;
  }

  @media (max-width: 960px) {
    .errorCenter{
      top: 34px;
      width: 64%;
      margin: 0px 18%;
    }
    .admin {
      width: 60%;
      margin: auto;
    }
    .admin .el-dialog {
      width: 90%;
      padding: 0 10%;
      box-sizing: border-box;
    }
    .admin .el-form-item__label {
      text-align: left;
      width: 5rem;
      padding: 0;
    }
    .admin .el-form-item .el-form-item__content {
      margin-left: 5rem;
      width: 70%;
    }
  }

  @media (max-width: 720px) {
    .admin {
      width: 80%;
      margin: auto;
    }
    .admin .el-dialog {
      padding: 0 5%;
    }
  }

  @media (max-width: 410px) {
    .admin {
      width: 100%;
      margin: auto;
    }
    .admin .el-dialog {
      padding: 0 5%;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue